export enum ImageCategories {
    photosCustomerNumber = 'P',
    photosBeforeInstallation = 'B',
    photosOfClosedPanel = 'C',
    photosOther = 'MISC',
    heaterPhotoDigitalScreen = 'DHP',
    heaterPhotoHeaterLabel = 'HLA',
    heaterDBOXWhole = 'W',
    heaterDBOXWiring = 'D',
    photoCannotInstallReason = 'DE',
    installerSignature = 'ISIG',
    customerSignature = 'SIG',
    quoteSignature = 'QSIG',
    dboxBack = 'DB',
    dboxFront = 'DF',
    dboxHolder = 'DH',
    customerAppPhoto = 'CAP',
    additionalPhotos = 'ADDP',
    screenshotAppDashboard = 'SAD',
    roomInterventionBefore = 'RIB',
    roomInterventionAfter = 'RIA',
    safetyRisksOrAnomalies = 'S',
}

export type ImageCategory = ImageCategories | `${ImageCategories}_${string}`;

type ImageInfo = {
    deepomaticWorkOrderId?: string;
    deepomaticTaskGroup?: string;
    deviceMacAddress?: string;
    controlType?: string;
    connectionType?: string;
    typepic: ImageCategory;
    typefic: string;
    image?: File;
    dataUri?: string;
} & (
    | {
          image: File;
      }
    | {
          dataUri: string;
      }
);

export default ImageInfo;
